import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Lottie from "lottie-react";
import dotsAnimation from "@carousel-office/shared-assets/dots.json";
export const InitializingScreen = ({ message = "Initializing Carousel...", }) => {
    return (_jsx("div", { className: "flex items-center justify-center h-full", children: _jsxs("div", { className: "inline-flex items-center gap-2 text-center text-gray-700 text-[15px]", children: [_jsx("span", { children: message }), _jsx(Lottie, { animationData: dotsAnimation, loop: true, autoplay: true, style: { width: 20, height: 20 } })] }) }));
};
